import i18n from '@/i18n';

function formatUtc(date: string, language: string, options: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(language, { timeZone: 'UTC', ...options }).format(
    new Date(`${date}T00:00:00Z`),
  );
}

/** Month/day without a weekday (e.g. "10/1"), for the board range label. */
export function formatMonthDay(date: string, language: string): string {
  return formatUtc(date, language, { month: 'numeric', day: 'numeric' });
}

/**
 * Month/day plus short weekday for a board date: "10/1 周四" in zh, "Thu 10/1"
 * in en. The order comes from the `dispatch.board.dayLabel` key, so a locale
 * owns its own word order. `date` is a YYYY-MM-DD calendar string, formatted
 * in UTC to keep the calendar day intact. `language` is the caller's
 * `i18n.language`.
 */
export function formatBatchDay(date: string, language: string): string {
  return i18n.t('dispatch.board.dayLabel', {
    lng: language,
    md: formatMonthDay(date, language),
    weekday: formatUtc(date, language, { weekday: 'short' }),
  });
}
